import { IRATypes } from '@interfaces/models/ira-types';
import { YesNoEmpty } from '@shared/models';

import { SharedContent } from './shared-content';

export const IraTypeContent = {
  pageTitle: `Tell us the type of IRA that you're transferring from `,
  pageTitleInherit: `Tell us the type of account you're inheriting from `,
  pageDescription: `If you're unsure, you can check a previous statement or give us a call at <span class="bold">877-662-7447</span>.`,
  inheritQuestion: {
    question: `Did {{name}} previously inherit the IRA?`,
    tooltip: `If the IRA was previously inherited by the decedent, it would be listed as an "Inherited IRA" on all of the account statements.`,
    answers: [YesNoEmpty.YES, YesNoEmpty.NO],
  },
  continueButton: 'Continue',
  errorText: SharedContent.radioRequiredError,
  iraAccountTypes: [
    {
      key: IRATypes.OTHER,
      value: 'Traditional, rollover, or SEP-IRA',
    },
    {
      key: IRATypes.INHERITED_OTHER,
      value: 'Inherited Traditional IRA',
    },
    {
      key: IRATypes.ROTH,
      value: 'Roth IRA',
    },
    {
      key: IRATypes.INHERITED_ROTH,
      value: 'Inherited Roth IRA',
    },
  ],
};
